  import React, { useEffect, useState } from "react";
import { Card, Form, Input, Select, Switch, Checkbox, Button, Space, Row, Col, Affix, DatePicker } from "antd";
import dayjs from "dayjs";
import { MailOutlined, InfoCircleOutlined, PhoneOutlined } from '@ant-design/icons';
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant'; // Define the date format
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ApiService from '../Components/apiService'; // Import ApiService class
import DynamicSelect from '../Record/DynamicSelectForLookup';
import { convertToDateJSON, convertDateToUserTimezone } from '../Components/Utility';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';


const { Option } = Select;
const EXCLUDED_FIELDS = ["CreatedBy", "createdAt", "LastModifiedBy", "lastModifiedAt", "recordCount"];

const UserFormCard = ({
    onFinish,
    fieldsData,
    onClose,
    loading,
    selectedRecord,
    activeCurrency,
    currencyMap,
    userRoles,
    setMapOfDateDateTimeFieldWithValue,
    mapOfDateDateTimeFieldWithValue,
    setSelectedUser,
    setDrawerVisible,
    form

}) => {

    const [lookupOptionforparent, setLookupOptionsForParent] = useState([]);
    const loginUserCurrency = Cookies.get('userCurrency');
    const security = useSelector((state) => state.data.items[0]);
    const [imageLocation, setImageLocation] = useState(null);

    // Fetch image location when selectedRecord.image exists
    useEffect(() => {
        const fetchImageLocation = async () => {
            if (selectedRecord?.image) {
                try {
                    const apiService = new ApiService(
                        `${BASE_URL}/image-uploads/${selectedRecord.image}`,
                        { "Content-Type": "application/json" },
                        "GET"
                    );
                    const response = await apiService.makeCall();
                    setImageLocation(response.location);
                } catch (error) {
                    console.error('Error fetching image location:', error);
                }
            }
        };
        fetchImageLocation();
    }, [selectedRecord?.image]);





    const handleSearch = async (value, fieldId, name, callback) => {
        const allFields = form.getFieldsValue();

        const filteredFields = Object.entries(allFields)
            .filter(([key, fieldValue]) => key !== name)
            .reduce((acc, [key, fieldValue]) => {
                acc[key] = fieldValue;
                return acc;
            }, {});
        if (value) {
            try {
                const apiService = new ApiService(`${BASE_URL}/search_lookup/${fieldId}/${value}`, {
                    'Content-Type': 'application/json', // Add any necessary headers, such as content type
                }, 'POST', { child_context: selectedRecord ? selectedRecord : filteredFields });
                const response = await apiService.makeCall();
                // Assuming the response data structure has options as an array
                setLookupOptionsForParent(prevOptions => ({
                    ...prevOptions,
                    [name]: response // Store the response for the specific field name
                }));
            } catch (error) {
                setLookupOptionsForParent(prevOptions => ({
                    ...prevOptions,
                    [name]: []
                }));
            } finally {
                callback();
            }
        } else {
            setLookupOptionsForParent(prevOptions => ({
                ...prevOptions,
                [name]: []
            }));
            callback();
        }
    };

    const renderFormItem = (field) => {
        const { name, label, type, picklist_values } = field;
        const isdisable = security?.object_settings?.User?.object_setting?.edit ? false : true;
        console.log("isdisable", isdisable);
        if (name === 'Currency' || name === 'currency') {
            return (
                <Form.Item
                    key={name}
                    label="Currency"
                    name="currency"
                    style={{ width: "100%" }}
                    rules={[{ required: true, message: "Please select a currency" }]}
                >
                    <Select showSearch placeholder="Select Currency" disabled={isdisable}
                    >
                        {activeCurrency?.map((currency) => (
                            <Option key={currency.iso_code} value={currency.iso_code}>
                                {currency.Name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            );
        }



        else if (name === 'user_role') {
            return (
                <Form.Item
                    key={name}
                    label="User Role"
                    name="user_role"
                    style={{ width: "100%", }}

                // rules={[{ required: true, message: "Please select a currency" }]}
                >
                    <Select
                        showSearch placeholder="Select Roles"
                        disabled={isdisable}

                    // style={{ height: 32 }} // reduce the select box height
                    // dropdownStyle={{ maxHeight: 100, overflowY: 'scroll' }} // make dropdown scrollable
                    >
                        {userRoles?.map((role) => (
                            <Option key={role.Name} value={role._id}>
                                {role.Name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            );
        }
        switch (type) {
            case 'String':
            case 'string':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                    >
                        <Input placeholder={`Enter ${field.label}`}
                            disabled={isdisable}
                        />
                    </Form.Item>
                );

            case 'integer':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here


                    >

                        <Input type="number" placeholder={`Enter ${field.label}`}
                            disabled={isdisable} />
                    </Form.Item>
                );

            case 'phone':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label} // Use the custom label here



                    >
                        <Input
                            placeholder={`Enter ${field.label}`}
                            addonBefore={
                                <PhoneOutlined style={{ cursor: 'pointer' }} />
                            }
                            disabled={isdisable}
                        />
                    </Form.Item>
                );

            case 'email':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                        rules={[
                            { type: 'email', message: 'The input is not valid E-mail!' },
                        ]}
                    >
                        <Input type='email' prefix={<MailOutlined />} placeholder="Enter email" disabled={isdisable}
                        />
                    </Form.Item>
                );

            case 'boolean':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        valuePropName="checked"
                        initialValue={false}

                    // label={field.label}  // Use the custom label here
                    >
                        <Checkbox disabled={isdisable}
                        >{field.label}</Checkbox>
                    </Form.Item>
                );

            case 'date':

                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                    >
                        <Space>
                            <DatePicker
                                placeholder={`Select ${field.label}`}
                                style={{ width: '100%' }}
                                format={DateFormat}
                                value={
                                    form.getFieldValue(name)
                                        ? convertToDateJSON(form.getFieldValue(name), DateFormat)
                                        : null
                                }
                                onChange={(date, dateString) => {
                                    form.setFieldsValue({ [name]: dateString });
                                    setMapOfDateDateTimeFieldWithValue(prev => ({
                                        ...prev,
                                        [name]: dateString
                                    }));
                                }}
                                disabled={isdisable}

                            />
                        </Space>
                    </Form.Item>
                );

            case 'datetime':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                    >
                        <Space>
                            <DatePicker
                                showTime
                                placeholder={`Select ${field.label}`}
                                style={{ width: '100%' }}
                                disabled={isdisable}
                                format={DateTimeFormat}
                                value={
                                    form.getFieldValue(name)
                                        ? convertToDateJSON(form.getFieldValue(name), DateTimeFormat)
                                        : null
                                }
                                onChange={(date, dateString) => {
                                    form.setFieldsValue({ [name]: dateString });
                                    setMapOfDateDateTimeFieldWithValue(prev => ({
                                        ...prev,
                                        [name]: dateString
                                    }));
                                }}
                            />
                        </Space>
                    </Form.Item>
                );

            case 'url':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                        rules={[
                            { type: 'url', message: 'Please enter a valid URL!' },
                        ]}
                    >
                        <Input type="url" placeholder={`Enter ${field.label}`} disabled={isdisable}
                        />
                    </Form.Item>
                );

            case 'currency':
                const currencyDecimalPlacesBefore = field.decimal_places_before;
                const currencyDecimalPlacesAfter = field.decimal_places_after;
                const regexPattern = new RegExp(`^\\d{1,${currencyDecimalPlacesBefore}}(\\.\\d{0,${currencyDecimalPlacesAfter}})?$`);
                const handleCurrencyInput = (event) => {
                    const inputValue = event.target.value;
                    if (!regexPattern.test(inputValue)) {
                        event.preventDefault();
                    }
                };

                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                    // initial={loginUserCurrency}
                    >
                        <Input
                            // addonBefore={currency || '$'}
                            placeholder={`Enter ${field.label}`}
                            onInput={handleCurrencyInput}
                            maxLength={currencyDecimalPlacesBefore + currencyDecimalPlacesAfter + 1}
                            disabled={isdisable}

                        />
                    </Form.Item>
                );

            case 'picklist':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}

                        label={field.label}
                        rules={[
                            ...(field.name === 'CurrencyIsoCode' ? [{ required: true, message: 'Currency is required' }] : []),
                        ]}
                        initialValue={field.name === 'CurrencyIsoCode' ? loginUserCurrency : undefined}
                    >
                        <Select
                            placeholder={`Select ${field.label}`}
                            allowClear
                            disabled={isdisable}

                        >
                            {field.picklist_values.map((value) => (
                                <Select.Option key={value} value={value}>
                                    {value}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                );



            case 'multiselect':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                    >
                        <Select
                            mode="multiple"
                            placeholder={`Select ${field.label}`}
                            allowClear
                            disabled={isdisable}

                        >
                            {field.picklist_values.map((value) => (
                                <Select.Option key={value} value={value}>
                                    {value}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                );

            case 'lookup':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}

                    >
                        <DynamicSelect
                            objectName={field.parent_object_name}
                            lookupConfig={field.lookup_config}
                            onSearch={handleSearch}
                            value={form.getFieldValue(field.name)}
                            name={field.name}
                            disabled={isdisable}

                            lookupOptionforparent={lookupOptionforparent}
                            fieldId={field._id}
                            onChange={(newValue) => form.setFieldsValue({ [field.name]: newValue })} // Update form value dynamically
                        />
                    </Form.Item>
                );

            case 'address':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}

                    >
                        <Card title="Enter Address" bordered={true}>
                            <Form.Item
                                key={`${field.name}_street`}
                                name={`${field.name}_street`}

                                label="Street"
                            >
                                <Input placeholder="Enter Street"
                                    disabled={isdisable}

                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field.name}_city`}
                                name={`${field.name}_city`}

                                label="City"
                            >
                                <Input placeholder="Enter City" disabled={isdisable}
                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field.name}_state`}
                                name={`${field.name}_state`}

                                label="State"
                            >
                                <Input placeholder="Enter State" disabled={isdisable}
                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field.name}_country`}
                                name={`${field.name}_country`}

                                label="Country"
                            >
                                <Input placeholder="Enter Country" disabled={isdisable}
                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field.name}_postalcode`}
                                name={`${field.name}_postalcode`}
                                label="Postal Code"

                            >
                                <Input placeholder="Enter Postal Code"
                                    disabled={isdisable}
                                />
                            </Form.Item>
                        </Card>
                    </Form.Item>
                );

            case 'decimal':
                const decimalPlacesBefore = field.decimal_places_before;
                const decimalPlacesAfter = field.decimal_places_after;
                const decimalPattern = new RegExp(`^\\d{1,${decimalPlacesBefore}}(\\.\\d{0,${decimalPlacesAfter}})?$`);

                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                    >
                        <Input
                            placeholder={`Enter ${field.label}`}
                            maxLength={decimalPlacesBefore + decimalPlacesAfter + 1}
                            onInput={(e) => {
                                const value = e.target.value;
                                if (!decimalPattern.test(value)) {
                                    e.preventDefault();
                                }
                            }}
                            disabled={isdisable}

                        />
                    </Form.Item>
                );

            case 'percentage':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}

                    >
                        <Input addonAfter="%" type="float" placeholder={`Enter ${field.label}`} disabled={isdisable}
                        />
                    </Form.Item>
                );

            case 'textarea':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}

                        label={field.label}  // Use the custom label here
                    >
                        <Input.TextArea
                            placeholder={`Enter ${field.label}`}
                            disabled={isdisable}

                        />
                    </Form.Item>
                );

            case 'image':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}  // Use the custom label here

                        rules={[
                            { type: 'url', message: 'Please enter a valid image URL!' },
                        ]}
                    >
                        <Input type="url" placeholder={`Enter ${field.label} URL`} disabled={isdisable}
                        />
                    </Form.Item>
                );

            case 'richtext':
                return (
                    <Form.Item
                        key={field.name}
                        name={field.name}
                        label={field.label}

                    >
                        <ReactQuill
                            value={form.getFieldValue(field.name)}
                            onChange={(value) => form.setFieldsValue({ [field.name]: value })}
                            placeholder={`Enter ${field.label}`}
                            theme="snow"
                            style={{ height: '200px', minHeight: '150px', paddingBottom: '40px', }}
                            disabled={isdisable}

                        />
                    </Form.Item>
                )

            default:
                return null;
        }
    };

    return (
        <Card title={
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontWeight: "bold", fontSize: "14px" }}>User details</div>
                <Button
                    type="primary"
                    style={{ marginBottom: 5, marginRight: "5px" }}
                    onClick={() => {
                        setSelectedUser(null);
                        setDrawerVisible(false);
                    }}
                >
                    Back
                </Button>
            </div>
        } bordered={false} style={{ maxWidth: "100%", height: "calc(100vh - 100px)", overflow: "hidden" }}>
            <div
                style={{
                    height: "calc(100vh - 180px)", 
                    overflowY: "auto",
                    paddingRight: 16,
                }}
            >
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    {fieldsData?.some((field) => field.name.toLowerCase() === "image") && (
                        <Form.Item name="image" style={{ width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                                {selectedRecord?.image && imageLocation ? (
                                    <>
                                        <img
                                            src={`${BASE_URL}/${imageLocation}`}
                                            alt="preview"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                objectFit: "cover",
                                                borderRadius: "6px",
                                                border: "1px solid #d9d9d9",
                                            }}
                                        />
                                        <Space>
                                            <Button
                                                onClick={() => {
                                                    const input = document.createElement("input");
                                                    input.type = "file";
                                                    input.accept = "image/*";
                                                    input.onchange = (e) => {
                                                        const file = e.target.files[0];
                                                        if (file) {
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                const base64String = reader.result.split(",")[1];
                                                                form.setFieldsValue({ image: base64String });
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    };
                                                    input.click();
                                                }}
                                            >
                                                Change
                                            </Button>
                                            <Button
                                                danger
                                                onClick={() => {
                                                    form.setFieldsValue({ image: null });
                                                    setImageLocation(null);
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </Space>
                                    </>
                                ) : (
                                    <Button
                                        onClick={() => {
                                            const input = document.createElement("input");
                                            input.type = "file";
                                            input.accept = "image/*";
                                            input.onchange = (e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    const reader = new FileReader();
                                                    reader.onloadend = () => {
                                                        const base64String = reader.result.split(",")[1];
                                                        form.setFieldsValue({ image: base64String });
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            };
                                            input.click();
                                        }}
                                    >
                                        Upload Image
                                    </Button>
                                )}
                            </div>
                        </Form.Item>
                    )}

                    <Row gutter={16}>
                        {fieldsData
                            ?.filter(
                                (field) =>
                                    field.name.toLowerCase() !== "image" && 
                                    !EXCLUDED_FIELDS.includes(field.name) &&
                                    field.label !== "Generate new password and notify user immediately"
                            )
                            .map((field) => (
                                <Col span={12} key={field.name}>
                                    {renderFormItem(field)}
                                </Col>
                            ))}
                    </Row>

                    {fieldsData?.find(
                        (field) => field.label === "Generate new password and notify user immediately"
                    ) && (
                            <Row>
                                <Col span={12}>
                                    {renderFormItem(
                                        fieldsData.find(
                                            (field) => field.label === "Generate new password and notify user immediately"
                                        )
                                    )}
                                </Col>
                            </Row>
                        )}

                    {security?.object_settings?.User?.object_setting?.edit && (
                        <Affix offsetBottom={0}>
                            <div
                                style={{
                                    width: '100%',
                                    padding: '10px 0',
                                    background: 'rgba(240, 242, 245, 0.9)',
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    zIndex: 1000,
                                }}
                            >
                                <Row justify="center">
                                    <Button onClick={onClose} style={{ marginRight: 8 }}>
                                        Cancel
                                    </Button>
                                    <Button type="primary" htmlType="submit" loading={loading}>
                                        Save
                                    </Button>
                                </Row>
                            </div>

                        </Affix>
                    )}


                </Form>
            </div>


        </Card>

    );


};

export default UserFormCard;
